import React, {useEffect} from 'react';
import {Layout} from 'antd';
import styled from 'styled-components';

import {useLanguages} from 'hooks/languages';
import {useAppStore} from 'hooks/app-store';

import {LoadingScreen} from 'components/loading-screen';

import {Topbar} from './components/topbar';
import {Sidebar} from './components/sidebar';

import {Router} from './router';

const Content = styled(Layout.Content)`
    display: flex;
    overflow: hidden;
    flex-direction: column;
`;

export default function PopupEditorApp() {
    const appStore = useAppStore();
    const languages = useLanguages();

    useEffect(() => {
        document.title = 'Popup Editor';
    }, []);

    if (languages.loading) {
        return <LoadingScreen/>;
    }

    const marginLeft = appStore.sidebarOpen ? 200 : 80;

    return (
        <Layout style={{minHeight: '100vh'}}>
            <Sidebar/>
            <Layout style={{marginLeft, transition: 'margin 0.2s'}}>
                <Layout>
                    <Topbar/>
                    <Content>
                        <Router/>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
}